const RELEVE_PRODUIT = {
  title: 'Edition des produits',
  breadcrumb: {
    racine: 'Accueil',
  },
  filter: {
    reference: 'Référence',
    libelle: 'Libellé',
    periodeVisualisation: 'Période',
    agence: 'Agence (s)',
  },
  action: {
    type: 'Edition',
  },
  buttons: {
    filtrer: 'Filtrer',
    edition: 'Editer ',
    pdf: '(en PDF)',
    docx: '(en Docx)',
  },
  typeProduit: {
    presse: 'Produit Presse',
    sponsoring: 'Produit Sponsoring',
    salon: 'Produit Salon',
    autre: 'Produit Autre',
    regroupement: 'Regroupement produit',
    total: 'Total',
  },
  noProduit: 'Aucun produit trouvé',
  selection: 'Sélection :',
  messageError: 'Impossible de faire l\'édition : aucun produit sélectionné',
};

export default RELEVE_PRODUIT;
